/// <reference path="../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var directives;
    (function (directives) {
        var SecurityMatrix = /** @class */ (function () {
            function SecurityMatrix() {
                this.templateUrl = './app/views/directives/securityMatrix.html';
                this.controller = [
                    '$scope', 'claimDefinitionService', 'systemLevelService', 'statusGroupService', 'securityMatrixService',
                    'conditionService', '$q', 'ModalService', 'treeService', 'processConfigurationService',
                    'relatedClaimProcessTypeService',
                    SecurityMatrixController
                ];
                this.controllerAs = 'controller';
                this.restrict = 'E';
                this.scope = {
                    matrix: "=",
                    processConfigurationId: "=",
                    hideReuse: "="
                };
            }
            SecurityMatrix.prototype.link = function ($scope, element, attrs) {
            };
            return SecurityMatrix;
        }());
        directives.SecurityMatrix = SecurityMatrix;
        var SecurityMatrixModel = /** @class */ (function () {
            function SecurityMatrixModel(securityMatrix, claimService, systemLevelService, statusService, securityMatrixService, conditionService, $q, modalService, processConfigurationId, $scope, treeService, processConfigurationService, relatedClaimProcessTypeService, hideReuse) {
                var _this = this;
                this.securityMatrix = securityMatrix;
                this.claimService = claimService;
                this.systemLevelService = systemLevelService;
                this.statusService = statusService;
                this.securityMatrixService = securityMatrixService;
                this.conditionService = conditionService;
                this.$q = $q;
                this.modalService = modalService;
                this.processConfigurationId = processConfigurationId;
                this.$scope = $scope;
                this.treeService = treeService;
                this.processConfigurationService = processConfigurationService;
                this.relatedClaimProcessTypeService = relatedClaimProcessTypeService;
                this.hideReuse = hideReuse;
                this.states = [];
                this.relatedProcessClaims = [];
                this.stateToStatusDictionary = {};
                this.statusToStateDictionary = {};
                this.securityMatrices = [];
                this.claimsAndStatesLoaded = false;
                this.isMatrixRebuilt = false;
                this.statusFilter = "";
                this.NO_SUBTYPE = "00000000-0000-0000-0000-000000000000";
                this.NO_STATE = "00000000-0000-0000-0000-000000000000";
                this.NO_CLAIM = "00000000-0000-0000-0000-000000000000";
                this.PROCESS_INITATOR = "89877FB0-0816-4263-947D-0159B7CC7AD2";
                this.logType = "SecurityMatrixModel";
                var self = this;
                this.alwaysShowSecurityMatrixTextHorizontal = false;
                this.excludedSecurityMatrixClaimsUniqueIds = [];
                this.showHideClaimLinks = false;
                var stringValueInLocalStorage = localStorage.getItem("alwaysShowSecurityMatrixTextHorizontal");
                if (stringValueInLocalStorage) {
                    this.alwaysShowSecurityMatrixTextHorizontal = JSON.parse(stringValueInLocalStorage);
                }
                stringValueInLocalStorage = localStorage.getItem("excludedSecurityMatrixClaimsUniqueIds");
                if (stringValueInLocalStorage) {
                    this.excludedSecurityMatrixClaimsUniqueIds = JSON.parse(stringValueInLocalStorage);
                }
                this.claimFilterFunction = function (claim) {
                    return _this.excludedSecurityMatrixClaimsUniqueIds.indexOf(claim.uniqueIdentifier) === -1;
                };
                self.matrixTypeString =
                    $scope.matrix.matrixType === 2 /* HideOrReadOnlyOrUpdateable */
                        ? "Advanced Security Matrix"
                        : $scope.matrix.matrixType === 1 /* HideOrShow */
                            ? "Security Matrix"
                            : $scope.matrix.matrixType === 3 /* SecurityRow */
                                ? "Security Row"
                                : "Security Row with Subtypes";
                if (!hideReuse) {
                    if (processConfigurationId) {
                        this.securityMatrixService.getProcessConfigurationSecurityMatrices(this.processConfigurationId)
                            .then(function (m) {
                            _this.securityMatrices.addRange(Enumerable.from(m)
                                .where(function (s) { return s.matrixType == $scope.matrix.matrixType; }).toArray());
                        });
                    }
                    this.securityMatrixService.getSystemLevelSecurityMatrices()
                        .then(function (m) {
                        _this.securityMatrices.addRange(Enumerable.from(m)
                            .where(function (s) { return s.matrixType == $scope.matrix.matrixType; }).toArray());
                        ;
                    });
                }
                $q.all([
                    this.getStates(),
                    systemLevelService.getSystemLevelClaims()
                        .then(function (systemLevel) {
                        self.systemClaims = Enumerable.from(systemLevel.myClaims).orderBy(function (i) { return i.type; }).toArray();
                    }),
                    this.getProcessConfigurationInfo()
                ])
                    .then(function () {
                    var d = _this.$q.defer();
                    if (_this.relatedClaimProcessTypes && _this.relatedClaimProcessTypes.length > 0) {
                        var relatedClaimsProcessed_1 = 0;
                        _this.relatedClaimProcessTypes.forEach(function (relatedClaimProcessType) {
                            var pertinentRelatedClaimUniqueIds = Enumerable.from(relatedClaimProcessType.relatedClaims).select(function (i) { return i.claimUniqueId; }).toArray();
                            _this.processConfigurationService.getRelatedProcessTypeClaims(relatedClaimProcessType.field.autoCompleteConfiguration.processType_id).then(function (relatedClaims) {
                                var pertinentRelatedClaims = Enumerable.from(relatedClaims)
                                    .where(function (i) { return pertinentRelatedClaimUniqueIds.indexOf(i.uniqueIdentifier) !== -1; })
                                    .toArray();
                                _this.relatedProcessClaims.addRange(pertinentRelatedClaims);
                                relatedClaimsProcessed_1++;
                                if (relatedClaimsProcessed_1 === _this.relatedClaimProcessTypes.length) {
                                    d.resolve();
                                }
                            });
                        });
                    }
                    else {
                        d.resolve();
                    }
                    return d.promise;
                })
                    .then(function () {
                    self.claims = [];
                    self.claims.addRange(self.processClaims);
                    self.claims.addRange(self.systemClaims);
                    self.claims.addRange(Enumerable.from(self.relatedProcessClaims).orderBy(function (i) { return i.type; }).toArray());
                    if (!_this.processConfigurationId) {
                        self.claims.push({
                            uniqueIdentifier: _this.PROCESS_INITATOR,
                            type: 'Process Initiator'
                        });
                    }
                    self.claims.push({
                        uniqueIdentifier: _this.NO_CLAIM,
                        type: 'No Claim'
                    });
                    if (Enumerable.from(self.claims).any(function (c) { return c.valueAssignable; })) {
                        _this.showTree = true;
                    }
                    _this.claimsAndStatesLoaded = true;
                    self.parseMatrix();
                    _this.isMatrixRebuilt = true;
                    //console.log(self.claims);
                });
                $scope.$watch('matrix', function (newValue, oldValue) {
                    _this.securityMatrix = _this.$scope.matrix;
                    if (newValue != null && _this.claimsAndStatesLoaded) {
                        _this.getStates().then(function (r) {
                            _this.selectedSubTypeId = _this.subTypes[0].uniqueIdentifier;
                            _this.parseMatrix();
                        });
                    }
                });
            }
            SecurityMatrixModel.prototype.securityMatrixChanged = function () {
                if (this.securityMatrix.reusedSecurityMatrix) {
                    this.securityMatrix.usesAnotherSecurityMatrix = true;
                }
                else {
                    this.securityMatrix.usesAnotherSecurityMatrix = false;
                }
                this.securityMatrixService.saveAllChanges();
            };
            SecurityMatrixModel.prototype.getClaimValueName = function (claimUniqueId) {
                if (!claimUniqueId)
                    return "";
                var id = this.securityMatrix.claimTreeItems[claimUniqueId];
                var treeItem = Enumerable.from(this.securityMatrix.claimBindings).singleOrDefault(function (c) { return c.id === id; });
                if (treeItem) {
                    return this.treeService.getDisplayName(treeItem);
                }
                return "";
            };
            SecurityMatrixModel.prototype.onDrop = function ($event, claimUniqueId) {
                var treeItem = this.treeService.createTreeItemFromItemDropped(function () {
                });
                this.securityMatrix.claimBindings.push(treeItem);
                this.securityMatrix.claimTreeItems[claimUniqueId] = treeItem.id;
                this.securityMatrix.claimTreeItemsJson = JSON.stringify(this.securityMatrix.claimTreeItems);
                this.securityMatrixService.saveAllChanges();
            };
            SecurityMatrixModel.prototype.viewSecurityMatrix = function (securityMatrix) {
                this.securityMatrixService.openViewSecurityMatrixModal(securityMatrix.id);
            };
            SecurityMatrixModel.prototype.filterReusableSecurityMatrices = function () {
                var _this = this;
                this.securityMatrices = Enumerable.from(this.securityMatrices)
                    .where(function (s) { return s.matrixType == _this.securityMatrix.matrixType; })
                    .toArray();
            };
            SecurityMatrixModel.prototype.parseMatrix = function () {
                var _this = this;
                var matrix = JSON.parse(this.securityMatrix.matrixJson);
                if (this.securityMatrix.matrixType === 3 /* SecurityRow */) {
                    this.selectedSubTypeId = this.NO_SUBTYPE;
                }
                if (this.securityMatrix.claimTreeItemsJson) {
                    this.securityMatrix.claimTreeItems = JSON.parse(this.securityMatrix.claimTreeItemsJson);
                }
                else {
                    this.securityMatrix.claimTreeItems = {};
                }
                var isChanged = false;
                if (!matrix) {
                    matrix = {};
                    if (this.securityMatrix.matrixType == 3 /* SecurityRow */) {
                        matrix[this.NO_SUBTYPE] = {};
                        matrix[this.NO_SUBTYPE][this.NO_STATE] = {};
                        this.claims.forEach(function (claim) {
                            matrix[_this.NO_SUBTYPE][_this.NO_STATE][claim.uniqueIdentifier] = {};
                        });
                    }
                    else if (this.securityMatrix.matrixType ===
                        4 /* SecurityRowWithSubType */) {
                        this.subTypes.forEach(function (subType) {
                            matrix[subType.uniqueIdentifier] = {};
                            _this.claims.forEach(function (claim) {
                                matrix[subType.uniqueIdentifier][_this.NO_STATE] = {};
                                matrix[subType.uniqueIdentifier][_this.NO_STATE][claim.uniqueIdentifier] = {};
                            });
                        });
                    }
                    else {
                        this.subTypes.forEach(function (subType) {
                            matrix[subType.uniqueIdentifier] = {};
                            _this.states.forEach(function (state) {
                                if (!state.isStatus) {
                                    //console.log(state);
                                    return;
                                }
                                matrix[subType.uniqueIdentifier][state.uniqueIdentifier] = {};
                                _this.claims.forEach(function (claim) {
                                    if (_this.securityMatrix.matrixType ==
                                        1 /* HideOrShow */) {
                                        matrix[subType.uniqueIdentifier][state.uniqueIdentifier][claim.uniqueIdentifier] = {
                                            show: false
                                        };
                                    }
                                    else {
                                        matrix[subType.uniqueIdentifier][state.uniqueIdentifier][claim.uniqueIdentifier] = {
                                            visibility: 'hidden'
                                        };
                                    }
                                });
                                if (_this.securityMatrix.matrixType ==
                                    1 /* HideOrShow */) {
                                    matrix[subType.uniqueIdentifier][state.uniqueIdentifier][_this.NO_CLAIM] = {
                                        show: false
                                    };
                                    if (!_this.processConfigurationId) {
                                        matrix[subType.uniqueIdentifier][state.uniqueIdentifier][_this.PROCESS_INITATOR] = {
                                            show: false
                                        };
                                    }
                                }
                                else {
                                    matrix[subType.uniqueIdentifier][state.uniqueIdentifier][_this.NO_CLAIM] = {
                                        visibility: 'hidden'
                                    };
                                    if (!_this.processConfigurationId) {
                                        matrix[subType.uniqueIdentifier][state.uniqueIdentifier][_this.PROCESS_INITATOR] = {
                                            visibility: 'hidden'
                                        };
                                    }
                                }
                            });
                        });
                    }
                    this.securityMatrix.matrix = matrix;
                }
                else if (matrix) {
                    for (var subType in matrix) {
                        var _loop_1 = function (stateId) {
                            if (matrix[subType].hasOwnProperty(stateId)) {
                                if (matrix[subType][stateId]) {
                                    if (!Enumerable.from(this_1.states).any(function (s) { return s.uniqueIdentifier === stateId; })) {
                                        if (stateId === "alwaysVisible") {
                                            return "continue";
                                        }
                                        delete matrix[subType][stateId];
                                        isChanged = true;
                                        return "continue";
                                    }
                                    var _loop_2 = function (claimUniqueId) {
                                        if (claimUniqueId === "isOverridden") {
                                            return "continue";
                                        }
                                        if (matrix.hasOwnProperty(stateId)) {
                                            if (matrix[subType][stateId]) {
                                                claimsEnumerable = Enumerable.from(this_1.claims);
                                                if (!claimsEnumerable.any(function (c) { return c.uniqueIdentifier === claimUniqueId; })) {
                                                    delete matrix[subType][stateId][claimUniqueId];
                                                    isChanged = true;
                                                    return "continue";
                                                }
                                                else {
                                                    if (this_1.securityMatrix.matrixType ==
                                                        2 /* HideOrReadOnlyOrUpdateable */) {
                                                        if (!matrix[subType][stateId][claimUniqueId].visibility) {
                                                            matrix[subType][stateId][claimUniqueId].visibility = 'hidden';
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    };
                                    for (var claimUniqueId in matrix[subType][stateId]) {
                                        _loop_2(claimUniqueId);
                                    }
                                }
                            }
                        };
                        var this_1 = this, claimsEnumerable;
                        for (var stateId in matrix[subType]) {
                            _loop_1(stateId);
                        }
                    }
                }
                this.securityMatrix.matrix = matrix;
                if (isChanged) {
                    this.matrixChanged();
                }
            };
            SecurityMatrixModel.prototype.selectAllClaim = function (claimId) {
                for (var state in this.securityMatrix.matrix[this.selectedSubTypeId]) {
                    this.securityMatrix.matrix[this.selectedSubTypeId][state][claimId].show = true;
                }
                this.saveMatrixChange();
            };
            SecurityMatrixModel.prototype.overrideStatusConfirm = function (statusId, stateName) {
                //this.statusOverrideName = stateName;
                this.overrideStatusId = statusId;
                this.isOverriding = true;
                this.isCollapsing = false;
                var result = confirm("Please confirm you want to configure security at the individual state level for status " + stateName);
                if (result) {
                    this.confirmOverride();
                }
                else {
                    this.cancelOverride();
                }
            };
            SecurityMatrixModel.prototype.undoOverrideStatusConfirm = function (statusId, stateName) {
                //this.statusOverrideName = stateName;
                this.overrideStatusId = statusId;
                this.isCollapsing = true;
                this.isOverriding = false;
                var result = confirm("Please confirm you want to configure security at the status level instead of the state level for status " + stateName);
                if (result) {
                    this.confirmOverride();
                }
                else {
                    this.cancelOverride();
                }
            };
            SecurityMatrixModel.prototype.toggleAlwaysShowSecurityMatrixTextHorizontal = function () {
                localStorage.setItem("alwaysShowSecurityMatrixTextHorizontal", JSON.stringify(this.alwaysShowSecurityMatrixTextHorizontal));
            };
            SecurityMatrixModel.prototype.getProcessConfigurationInfo = function () {
                var _this = this;
                var d = this.$q.defer();
                if (this.processConfigurationId) {
                    this.$q.all([
                        this.processConfigurationService.getPermitSubTypeInfo(this.processConfigurationId)
                            .then(function (r) {
                            if (r) {
                                _this.subTypes = Enumerable.from(r.mySubTypeConfiguration.myProcessSubTypes).orderBy(function (i) { return i.name; }).toArray();
                                if (_this.subTypes.length === 1) {
                                    _this.selectedSubTypeId = _this.subTypes[0].uniqueIdentifier;
                                }
                            }
                        }),
                        this.claimService.getAllProcessClaims(this.processConfigurationId)
                            .then(function (claims) {
                            _this.processClaims = Enumerable.from(claims).orderBy(function (i) { return i.type; }).toArray();
                        }),
                        this.conditionService.getAllConditions(this.processConfigurationId)
                            .then(function (conditions) {
                            _this.conditions = conditions;
                        }),
                        this.relatedClaimProcessTypeService.getRelatedClaims(this.processConfigurationId)
                            .then(function (r) {
                            _this.relatedClaimProcessTypes = r;
                        })
                    ])
                        .then(function () {
                        d.resolve();
                    });
                }
                else {
                    this.systemLevelService.getSystemLevelSubTypeGroups().then(function (systemLevel) {
                        _this.subTypes = [];
                        Enumerable.from(systemLevel.mySubTypeGroups).orderBy(function (i) { return i.name; }).forEach(function (subType) {
                            _this.subTypes.push({
                                name: subType.name,
                                uniqueIdentifier: subType.id
                            });
                        });
                        if (_this.subTypes.length === 1) {
                            _this.selectedSubTypeId = _this.subTypes[0].uniqueIdentifier;
                        }
                        d.resolve();
                    });
                }
                return d.promise;
            };
            SecurityMatrixModel.prototype.getStates = function () {
                var _this = this;
                this.states = [];
                var d = this.$q.defer();
                if (this.securityMatrix.matrixType ===
                    4 /* SecurityRowWithSubType */ ||
                    this.securityMatrix.matrixType === 3 /* SecurityRow */) {
                    this.states.push({
                        sortName: "NO STATUS",
                        name: "NO STATE",
                        uniqueIdentifier: this.NO_STATE,
                        isStatus: true
                    });
                    //console.log(this.states);
                    d.resolve();
                }
                else if (this.processConfigurationId) {
                    this.statusService.getProcessStatesWithDetails(this.processConfigurationId)
                        .then(function (result) {
                        var statusGroups = Enumerable.from(result.statusGroups).orderBy(function (i) { return i.statusName; }).toArray();
                        statusGroups.forEach(function (p) {
                            var newStatus = {
                                sortName: p.statusName,
                                name: p.statusName,
                                isStatus: true,
                                uniqueIdentifier: p.uniqueIdentifier
                            };
                            _this.states.push(newStatus);
                            _this.statusToStateDictionary[p.uniqueIdentifier] = [];
                            var stateWorkflowBlocks = Enumerable.from(p.workflowBlocks)
                                .where(function (i) { return i.blockType === 0 /* State */; })
                                .orderBy(function (i) { return i.name; })
                                .toArray();
                            stateWorkflowBlocks.forEach(function (workflowBlock) {
                                if (workflowBlock.blockType !== 0 /* State */)
                                    return;
                                _this.stateToStatusDictionary[workflowBlock.myStateDto.stateCodeUniqueId] = p.uniqueIdentifier;
                                _this.statusToStateDictionary[p.uniqueIdentifier].push(workflowBlock.myStateDto.stateCodeUniqueId);
                                var newState = {
                                    sortName: p.statusName + workflowBlock.name,
                                    name: workflowBlock.name,
                                    isStatus: false,
                                    uniqueIdentifier: workflowBlock.myStateDto.stateCodeUniqueId
                                };
                                _this.states.push(newState);
                            });
                        });
                        d.resolve();
                    });
                }
                else {
                    this.systemLevelService.getSystemLevelStatusesAndStates().then(function (system) {
                        Enumerable.from(system.statusCodeGroup.myStatuses).orderBy(function (i) { return i.shortDescription; }).forEach(function (s) {
                            var newStatus = {
                                sortName: s.shortDescription,
                                name: s.shortDescription,
                                isStatus: true,
                                uniqueIdentifier: s.uniqueIdentifier
                            };
                            _this.statusToStateDictionary[s.uniqueIdentifier] = [];
                            _this.states.push(newStatus);
                            var stateCodes = Enumerable.from(s.myStates)
                                .orderBy(function (i) { return i.shortDescription; })
                                .toArray();
                            stateCodes.forEach(function (state) {
                                var newState = {
                                    sortName: s.shortDescription + state.shortDescription,
                                    name: state.shortDescription,
                                    isStatus: false,
                                    uniqueIdentifier: state.uniqueIdentifier
                                };
                                _this.stateToStatusDictionary[state.uniqueIdentifier] = s.uniqueIdentifier;
                                _this.statusToStateDictionary[s.uniqueIdentifier].push(newState.uniqueIdentifier);
                                _this.states.push(newState);
                            });
                        });
                        _this.states = Enumerable.from(_this.states).orderBy(function (i) { return i.name; }).toArray();
                        d.resolve();
                    });
                }
                return d.promise;
            };
            SecurityMatrixModel.prototype.cancelOverride = function () {
                this.statusOverrideName = null;
                this.overrideStatusId = null;
                this.isCollapsing = false;
                this.isOverriding = false;
            };
            SecurityMatrixModel.prototype.confirmOverride = function () {
                if (this.isOverriding) {
                    this.overrideStatus(this.overrideStatusId);
                }
                else if (this.isCollapsing) {
                    this.undoOverrideStatus(this.overrideStatusId);
                }
                this.cancelOverride();
            };
            SecurityMatrixModel.prototype.pasteState = function (stateId) {
                var copyObj = JSON.parse(JSON.stringify(this.securityMatrix.matrix[this.selectedSubTypeId][this.copyStateId]));
                this.securityMatrix.matrix[this.selectedSubTypeId][stateId] = copyObj;
                this.matrixChanged();
            };
            SecurityMatrixModel.prototype.pasteSubType = function () {
                var copyObj = JSON.parse(JSON.stringify(this.securityMatrix.matrix[this.copySubTypeId]));
                this.securityMatrix.matrix[this.selectedSubTypeId] = copyObj;
                this.matrixChanged();
            };
            SecurityMatrixModel.prototype.overrideStatus = function (statusId) {
                var _this = this;
                var object = this.securityMatrix.matrix[this.selectedSubTypeId][statusId];
                if (!object) {
                    object = this.securityMatrix.matrix[this.selectedSubTypeId][statusId] = {
                        isOverridden: true
                    };
                }
                object.isOverridden = true;
                for (var propName in object) {
                    if (object.hasOwnProperty(propName)) {
                        if (propName === "isOverridden") {
                            continue;
                        }
                        delete object[propName];
                    }
                }
                if (this.securityMatrix.matrixType ===
                    2 /* HideOrReadOnlyOrUpdateable */) {
                    this.statusToStateDictionary[statusId].forEach(function (state) {
                        _this.securityMatrix.matrix[_this.selectedSubTypeId][state] = {};
                        _this.claims.forEach(function (claim) {
                            _this.securityMatrix.matrix[_this.selectedSubTypeId][state][claim.uniqueIdentifier] = { visibility: 'hidden' };
                        });
                    });
                }
                this.matrixChanged();
            };
            SecurityMatrixModel.prototype.undoOverrideStatus = function (statusId) {
                var _this = this;
                this.securityMatrix.matrix[this.selectedSubTypeId][statusId].isOverridden = false;
                this.statusToStateDictionary[statusId].forEach(function (state) {
                    delete _this.securityMatrix.matrix[_this.selectedSubTypeId][state];
                });
                if (this.securityMatrix.matrixType ===
                    2 /* HideOrReadOnlyOrUpdateable */) {
                    this.securityMatrix.matrix[this.selectedSubTypeId][statusId] = {};
                    this.claims.forEach(function (claim) {
                        _this.securityMatrix.matrix[_this.selectedSubTypeId][statusId][claim.uniqueIdentifier] = { visibility: 'hidden' };
                    });
                }
                this.matrixChanged();
            };
            SecurityMatrixModel.prototype.matrixChanged = function (stateId, claimUniqueId, propertyName) {
                if (stateId && claimUniqueId) {
                    delete this.securityMatrix.matrix[this.selectedSubTypeId][stateId][claimUniqueId].condition_id;
                    if (this.stateToStatusDictionary[stateId]) {
                        this.securityMatrix.matrix[this.selectedSubTypeId][stateId][claimUniqueId].isStatus = true;
                    }
                }
                this.saveMatrixChange();
            };
            SecurityMatrixModel.prototype.saveMatrixChange = function () {
                this.securityMatrix.matrixJson = JSON.stringify(this.securityMatrix.matrix);
                this.securityMatrixService.saveAllChanges();
            };
            SecurityMatrixModel.prototype.conditionChanged = function () {
                this.securityMatrixService.saveAllChanges();
            };
            SecurityMatrixModel.prototype.isAlwaysVisible = function () {
                this.securityMatrix.condition = null;
                this.saveMatrixChange();
                this.securityMatrixService.saveAllChanges();
            };
            SecurityMatrixModel.prototype.addCondition = function (claim, state) {
                var self = this;
                this.modalService.showModal({
                    templateUrl: "./app/views/modals/securityMatrixConditionModal.html",
                    controller: "securityMatrixConditionModalController",
                    inputs: {
                        claim: claim,
                        matrix: self.securityMatrix.matrix,
                        state: state,
                        conditions: self.conditions
                    }
                })
                    .then(function (modal) {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.
                    modal.element.modal();
                    modal.close.then(function (result) {
                        if (result) {
                            self.matrixChanged();
                        }
                        else {
                            self.parseMatrix();
                        }
                    });
                });
            };
            SecurityMatrixModel.prototype.hideClaim = function (claim) {
                this.excludedSecurityMatrixClaimsUniqueIds.push(claim.uniqueIdentifier);
            };
            SecurityMatrixModel.prototype.showAllClaims = function () {
                this.excludedSecurityMatrixClaimsUniqueIds = [];
            };
            SecurityMatrixModel.prototype.saveHiddenClaims = function () {
                localStorage.setItem("excludedSecurityMatrixClaimsUniqueIds", JSON.stringify(this.excludedSecurityMatrixClaimsUniqueIds));
            };
            return SecurityMatrixModel;
        }());
        directives.SecurityMatrixModel = SecurityMatrixModel;
        var SecurityMatrixController = /** @class */ (function () {
            function SecurityMatrixController($scope, claimService, systemLevelService, statusService, securityMatrixService, conditionService, $q, modalService, treeService, processConfigurationService, relatedClaimProcessTypeService) {
                $scope.model = new SecurityMatrixModel($scope.matrix, claimService, systemLevelService, statusService, securityMatrixService, conditionService, $q, modalService, $scope.processConfigurationId, $scope, treeService, processConfigurationService, relatedClaimProcessTypeService, $scope.hideReuse);
            }
            return SecurityMatrixController;
        }());
        directives.SecurityMatrixController = SecurityMatrixController;
    })(directives = warsApp.directives || (warsApp.directives = {}));
})(warsApp || (warsApp = {}));
warsApp.registerDirective('SecurityMatrix', []);
